import { Button as ButtonTypographySize } from '../Typography/constants/button.size';
import { ButtonSmall as ButtonSmallTypographySize } from '../Typography/constants/button-small.size';
export var BUTTON_SHAKE_ANIMATION_DURATION = 550; // Default buttons padding

export var BUTTON_MEDIUM_PADDING = {
  xs: '14px 32px',
  sm: '13px 32px',
  md: '15px 32px',
  lg: '13px 32px',
  xl: '16px 32px'
};
export var BUTTON_MEDIUM_PADDING_FULL_WIDTH = {
  xs: '14px 14px',
  sm: '13px 14px',
  md: '15px 16px',
  lg: '13px 18px',
  xl: '16px 20px'
};
export var BUTTON_MEDIUM_NEGATIVE_MARGIN_FULL_WIDTH = {
  xs: '-14px -14px',
  sm: '-13px -14px',
  md: '-15px -16px',
  lg: '-13px -18px',
  xl: '-16px -20px'
};
export var BUTTON_SMALL_PADDING = {
  xs: '8px 16px',
  md: '8px 20px',
  lg: '8px 24px'
};
export var BUTTON_SMALL_PADDING_FULL_WIDTH = '8px 12px';
export var BUTTON_SMALL_NEGATIVE_MARGIN_FULL_WIDTH = '-8px -12px';
export var BUTTON_PILL_MEDIUM_PADDING = {
  xs: '4px 12px',
  md: '4px 14px',
  lg: '6px 16px',
  xl: '6px 18px'
};
export var BUTTON_PILL_MEDIUM_PADDING_FULL_WIDTH = {
  xs: '4px 8px',
  lg: '6px 8px'
};
export var BUTTON_PILL_SMALL_PADDING = {
  xs: '3px 12px',
  lg: '4px 14px'
};
export var BUTTON_PILL_SMALL_PADDING_FULL_WIDTH = {
  xs: '3px 8px',
  lg: '4px 8px'
};
export var BUTTON_WITH_PROGRESS_ICON_SIZE = {
  xs: 26,
  md: 30,
  xl: 32
};
export var BUTTON_SQUARE_SIZE = {
  xs: 30,
  sm: 30,
  md: 30,
  lg: 32,
  xl: 34
};
export var BUTTON_SQUARE_SIZE_SMALL = {
  xs: 26,
  sm: 26,
  md: 26,
  lg: 28,
  xl: 30
};
export var BUTTON_SQUARE_SIZE_TINY = {
  xs: 20,
  sm: 20,
  md: 22,
  lg: 24,
  xl: 28
};
export var BUTTON_CIRCLE_SIZE = {
  xs: 32,
  sm: 32,
  md: 32,
  lg: 34,
  xl: 36
};
export var BUTTON_CIRCLE_SIZE_SMALL = {
  xs: 26,
  sm: 26,
  md: 28,
  lg: 30,
  xl: 32
};
export var BUTTON_CIRCLE_SIZE_TINY = {
  xs: 20,
  sm: 20,
  md: 22,
  lg: 24,
  xl: 28
};
export var BUTTON_ICON_HORIZONTAL_MARGIN = {
  xs: 8,
  lg: 10
};
export var BUTTON_PILL_MEDIUM_ICON_HORIZONTAL_MARGIN = {
  xs: 4,
  md: 6,
  xl: 8
};
export var BUTTON_PILL_SMALL_ICON_HORIZONTAL_MARGIN = {
  xs: 3,
  md: 4,
  xl: 6
};
export var BUTTON_RESET_TIME = 2000;
export var BUTTON_RESET_WITH_ERROR_TIME = 3000;
export var BUTTON_PROGRESS_TIME = 4000;
export var BUTTON_HANDLE_OUTER_SIZE = {
  xs: 64,
  md: 44
};
export var BUTTON_FONT_SIZE = {
  medium: ButtonTypographySize.fontSize,
  small: ButtonSmallTypographySize.fontSize
};
export var BUTTON_LINE_HEIGHT = {
  medium: ButtonTypographySize.lineHeight,
  small: ButtonSmallTypographySize.lineHeight
};